import { Shield, UserCog, Building2, Briefcase, Users as UsersIcon, BadgeDollarSign, Headset } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

/** Valores de tipo de usuário (espelham App\Enums\Users\UserTypeEnum). */
export const USER_TYPE = {
  ADMINISTRATOR: 'ADMINISTRADOR',
  COLLABORATOR:  'COLABORADOR',
  DIRECTOR:      'DIRETOR',
  SUPERVISOR:    'SUPERVISOR',
  AFFILIATE:     'AFILIADO',
  SELLER:        'VENDEDOR',
  COMPANY:       'EMPRESA',
} as const

export interface UserTypeMeta { value: string; label: string; icon: LucideIcon; description: string }

export const USER_TYPE_META: Record<string, UserTypeMeta> = {
  ADMINISTRADOR: { value: 'ADMINISTRADOR', label: 'Administrador', icon: Shield,        description: 'Acesso total ao sistema, automaticamente.' },
  COLABORADOR:   { value: 'COLABORADOR',   label: 'Colaborador',   icon: UserCog,        description: 'Acesso conforme a hierarquia atribuída.' },
  DIRETOR:       { value: 'DIRETOR',       label: 'Diretor',       icon: Briefcase,      description: 'Diretoria comercial.' },
  SUPERVISOR:    { value: 'SUPERVISOR',    label: 'Supervisor',    icon: Headset,        description: 'Supervisão comercial.' },
  AFILIADO:      { value: 'AFILIADO',      label: 'Afiliado',      icon: BadgeDollarSign, description: 'Afiliado.' },
  VENDEDOR:      { value: 'VENDEDOR',      label: 'Vendedor',      icon: UsersIcon,      description: 'Vendedor.' },
  EMPRESA:       { value: 'EMPRESA',       label: 'Empresa',       icon: Building2,      description: 'Portal da empresa.' },
}

/** Rótulo amigável para um tipo (case-flexível). */
export function userTypeLabel(type?: string | null): string {
  if (!type) return '—'
  return USER_TYPE_META[type.toUpperCase()]?.label ?? type
}

/** Tipos gerenciados por este painel (Administrador + Colaborador). */
export const ADMIN_PANEL_TYPES = [USER_TYPE.ADMINISTRATOR, USER_TYPE.COLLABORATOR]
